import React from 'react';
import { InputBase } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { color } from '../../constant/cssVariables';

const useStyles = makeStyles(() => ({
  input: {
    width: '100%',
    fontSize: '16px',
    backgroundColor: 'transparent',
    color: 'inherit',
    padding: '4px 0',
    borderBottom: `1px solid ${color.black}`, 
    transition: 'border-color 0.3s ease',

    '&:focus': {
      outline: 'none',
      borderBottom: `2px solid ${color.black}`, 
    },

    '&:hover': {
      borderBottom: `2px solid ${color.black}`,
    },

    
  },
}));

const InputFieldComponent = ({className="",fullWidth=false,name, value, onChange,type,maxLength=524288, isMultiline = false, minRows = 0, id = "", placeholder = "",disabled=false }: any) => {

  const classes = useStyles()
  return (
    <InputBase
      id={id}
      className={className || classes.input}
      name={name}
      
      slotProps={{
        input:{
          // pattern:"[A-Z]",
          type:type,
          maxLength:maxLength,
          disabled:disabled
        }
      }}
      // type={type}
      value={value}
      placeholder={placeholder}
      multiline={isMultiline}
      minRows={isMultiline && minRows}
      onChange={onChange}
      fullWidth={fullWidth}
      inputProps={{ 'aria-label': 'custom input' }}
    />
  );
};

export default InputFieldComponent;
